import { render, staticRenderFns } from "./PublisherPicker.vue?vue&type=template&id=50cf6908&"
import script from "./PublisherPicker.vue?vue&type=script&lang=js&"
export * from "./PublisherPicker.vue?vue&type=script&lang=js&"
import style0 from "./PublisherPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports